module.exports = __webpack_public_path__ + "img/product_bg.6cd8508.webp";